import { createAction, props } from '@ngrx/store';

export const TabIndexChanged = createAction(
  '[Tickets: Tickets Actions]: Tab Index Changed',
  props<{ tabIndex: number }>(),
);
